
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrar",
      function () {
        return require("private-next-pages/entrar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entrar"])
      });
    }
  